'use strict';

var App = require('app');
var OOP = require('utils/oop');
var I18N = require('utils/i18n');
var Notification = require('utils/notification');
var Utils = require('components/common/utils');

module.exports = OOP.extend(Marionette.ItemView, {
    template: require('components/profile/templates/label_pool'),

    events: OOP.inheritedObj('events', {
        'click button.js-btn-edit': function () {
            this.options.controller.showLabelPoolDialog();
        },
        'click button.js-btn-delete': function () {
            Utils.showConfirmationDialog({
                title: I18N.TR('Label Vorgaben löschen'),
                hint: I18N.TR(
                    'Wollen Sie wirklich die Label Vorgaben löschen? Die zugewiesenen Geräte-Label bleiben erhalten.'
                ),
                action_label: I18N.TR('Löschen'),
                action_cb: function () {
                    $.when(App.request('label:pool:delete')).done(function (result) {
                        if (result) {
                            Notification.show(
                                'error',
                                I18N.TR('Fehler'),
                                I18N.TR('Label Vorgaben konnten nicht gelöscht werden.')
                            );
                            return;
                        }

                        Backbone.history.loadUrl(Backbone.history.fragment);
                    });
                },
            });
        },
    }),

    serializeData: function () {
        return {
            pool: this.options.pool,
        };
    },
});
